// ui/atoms/Button.tsx
import styled from "styled-components";

export const Button = styled.button<{ $variant?: "primary" | "secondary" | "danger" | "transparent", $size?: 'small' | 'medium' | 'large' }>`
  padding: ${({ $size }) => $size === 'small' ? '4px 8px' : $size === 'large' ? '10px 20px' : '12px 24px'};
  font-size: ${({ $size }) => $size === 'small' ? '12px' : $size === 'large' ? '20px' : '16px'};
  font-weight: bold;
  border: none;
  border-radius: 4px;
  background-color: ${({ theme, $variant }) =>
    $variant === "primary"
      ? theme.colors.primary
      : $variant === "danger"
      ? theme.colors.danger
      : $variant === "transparent"
      ? "transparent"
      : theme.colors.secondary};
  color: #fff;
  cursor: pointer;

  &:hover {
    background-color: ${({ theme, $variant }) =>
      $variant === "primary"
        ? theme.colors.primaryHover
        : $variant === "danger"
        ? theme.colors.danger
        : theme.colors.secondaryHover};
  }
`;

export const DangerButton = styled(Button)`
  background: ${({ theme }) => theme.colors.danger};
`;

export const PrimaryButton = styled(Button)`
  background: ${({ theme }) => theme.colors.primary};
`;

export const SecondaryButton = styled(Button)`
  background: ${({ theme }) => theme.colors.secondary};
`;

export const TransparentButton = styled(Button)`
  background-color: transparent;
  color: #333;

  &:hover {
      background-color: #ccc;
      color: #333;
  }
`;

export const Label = styled.label<{ $variant?: 'primary' | 'secondary' | 'danger', $size?: 'small' | 'medium' | 'large' }>`
  padding: ${({ $size }) => $size === 'small' ? '4px 8px' : $size === 'large' ? '10px 20px' : '6px 12px'};
  font-size: ${({ $size }) => $size === 'small' ? '12px' : $size === 'large' ? '20px' : '16px'};
  font-weight: bold;
  border: none;
  border-radius: 4px;
  background-color: ${({ theme, $variant }) =>
    $variant === "primary"
      ? theme.colors.primary
      : $variant === "danger"
      ? theme.colors.danger
      : theme.colors.secondary};
  color: #fff;
  cursor: pointer;

  &:hover {
    background-color: ${({ theme, $variant }) =>
      $variant === "primary"
        ? theme.colors.primaryHover
        : $variant === "danger"
        ? theme.colors.danger
        : theme.colors.secondaryHover};
  }

  &:focus {
      outline: none;
      box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.3);
  }
`;


export const Select = styled.select<{$variant?: 'primary' | 'secondary' | 'danger', $size?: 'small' | 'medium' | 'large' }>`
  padding: ${({ $size }) => $size === 'small' ? '4px 8px' : $size === 'large' ? '10px 20px' : '8px'};
  font-size: ${({ $size }) => $size === 'small' ? '12px' : $size === 'large' ? '20px' : '16px'};
  font-weight: bold;
  border: none;
  border-radius: 4px;
  background-color: ${({ theme, $variant }) =>
    $variant === "primary"
      ? theme.colors.primary
      : $variant === "danger"
      ? theme.colors.danger
      : theme.colors.secondary};
  color: #fff;
  cursor: pointer;

  &:hover {
    background-color: ${({ theme, $variant }) =>
      $variant === "primary"
        ? theme.colors.primaryHover
        : $variant === "danger"
        ? theme.colors.danger
        : theme.colors.secondaryHover};
  }

  &:focus {
      outline: none;
      box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.3);
  }
`;

export const Option = styled.option<{$variant?: 'primary' | 'secondary' | 'danger', $size?: 'small' | 'medium' | 'large'}>`
  padding: ${({ $size }) => $size === 'small' ? '4px 8px' : $size === 'large' ? '10px 20px' : '8px'};
  font-size: ${({ $size }) => $size === 'small' ? '12px' : $size === 'large' ? '20px' : '16px'};
  font-weight: bold;
  border: none;
  border-radius: 4px;
  background-color: ${({ theme, $variant }) =>
    $variant === "primary"
      ? theme.colors.primary
      : $variant === "danger"
      ? theme.colors.danger
      : theme.colors.secondary};
  color: #fff;
  cursor: pointer;
`;

export const ButtonGroup = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const BorderedButtonGroup = styled(ButtonGroup)`
  border: 1px solid #ddd;
  padding: 4px;
  border-radius: 4px;
`;